import { tv } from '@change/ds-utils';

export const FooterStyles = tv({
	base: 'bg-[#403A49]',
	variants: {
		size: {
			small: 'px-1.5 py-1',
			medium: 'px-[8.5px] py-[7px]',
			large: 'px-3 py-[9px]',
		},
	},
});

export const StoryFooterStyles = tv({
	base: '',
	variants: {
		size: {
			small: 'h-2.5',
			medium: 'h-[21px]',
			large: 'h-6',
		},
	},
});
